module.exports = __webpack_public_path__ + "media/images/email/rewards/googleplay-5517bcc7975807085715ddbd4a6df7ce.png";